import { render, staticRenderFns } from "./RegisterDogIndividual.vue?vue&type=template&id=b21f06a8"
import script from "./RegisterDogIndividual.vue?vue&type=script&lang=ts"
export * from "./RegisterDogIndividual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports